import { BookingPageQueryParam } from 'common/navigation';

function getQueryParam(params: URLSearchParams, param: BookingPageQueryParam): string | null {
  return params.get(param);
}

export default getQueryParam;
